export const SET_COURSE_DATA = 'SET_COURSE_DATA';
export const SET_COURSE_LOADING = 'SET_COURSE_LOADING';
export const SET_COURSE_ERROR = 'SET_COURSE_ERROR';
export const SET_CURRENT_LESSON_PROGRESS = 'SET_CURRENT_LESSON_PROGRESS';
export const SET_CURRICULUM_GRADE_AND_SUBJECT =
  'SET_CURRICULUM_GRADE_AND_SUBJECT';
export const SET_CURRICULUM_LIST = 'SET_CURRICULUM_LIST';
export const SET_SHOW_UNIT_SELECTION_SCREEN = 'SET_SHOW_UNIT_SELECTION_SCREEN';
export const SET_LAST_QUESTION = 'SET_LAST_QUESTION';
export const SET_START__LAST_QUESTION_ONE_TO_ONE =
  'SET_START__LAST_QUESTION_ONE_TO_ONE';
